import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["row"]
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-drag-handle]",
      animation: 150,
      onEnd: () => this.renumber(),
    })
  }
  renumber() {
    this.element.querySelectorAll("[data-position-input]").forEach((input, i) => { input.value = i })
  }
  disconnect() { this.sortable?.destroy() }
}
